import { call, put, select } from 'redux-saga/effects';

import request from '../request';
import selectors from '../../../selectors';
import actions from '../../../actions';
import api from '../../../api';

export function* fetchMonthlyReportInCurrentBoard(year, month, listId, pointSystemIdParam = null) {
  let pointSystemId = pointSystemIdParam;

  if (!pointSystemId) {
    const pointSystem = yield select(selectors.selectPointSystemForCurrentBoard);
    if (!pointSystem) {
      return;
    }
    pointSystemId = pointSystem.id;
  }

  const y = Number(year);
  const m = Number(month);

  yield put(actions.fetchMonthlyReport(pointSystemId, y, m));

  let item;
  try {
    ({ item } = yield call(request, api.getMonthlyReport, pointSystemId, { year: y, month: m, listId }));
  } catch (error) {
    yield put(actions.fetchMonthlyReport.failure(error));
    return;
  }

  yield put(actions.fetchMonthlyReport.success(item));

  if (item?.employeePlans?.length > 0) {
    const plansPointSystemId = item.employeePlans[0].pointSystemId || pointSystemId;
    yield put(actions.fetchEmployeePlans.success(plansPointSystemId, item.employeePlans));
  }
}

export default {
  fetchMonthlyReportInCurrentBoard,
};

